var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07668 1.21993C8.41827 0.398638 9.58173 0.398636 9.92332 1.21993L11.675 5.4314C11.819 5.77764 12.1446 6.01421 12.5184 6.04418L17.065 6.40868C17.9517 6.47976 18.3112 7.58627 17.6357 8.16494L14.1716 11.1323C13.8868 11.3762 13.7624 11.759 13.8495 12.1238L14.9078 16.5605C15.1142 17.4257 14.1729 18.1096 13.4138 17.6459L9.52125 15.2684C9.20124 15.0729 8.79876 15.0729 8.47875 15.2684L4.58619 17.6459C3.82709 18.1096 2.88583 17.4257 3.09222 16.5605L4.15055 12.1238C4.23756 11.759 4.11318 11.3762 3.8284 11.1323L0.364336 8.16494C-0.311201 7.58627 0.0483234 6.47976 0.934978 6.40868L5.48162 6.04418C5.85541 6.01421 6.18102 5.77764 6.32503 5.43141L8.07668 1.21993Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.c531d6c48526a3196191f2687b066446.svg";
export { ForwardRef as ReactComponent };